let bootstrap = require('bootstrap')
$(function () {
    $('[data-load-modal]').click(function () {
        var self = $(this);
        var target = $("#" + self.data('load-modal-target'));
        var title = self.data('load-modal-title');
        target.find(".modal-loaded").hide();
        target.find(".modal-loading").show();
        target.find(".modal-title").text(title);
        let modal = bootstrap.Modal.getOrCreateInstance("#" + self.data('load-modal-target'));
        modal.show();
        $.get(self.data('load-modal'), function (res) {
                target.find(".modal-loading").hide();

                target.find(".modal-loaded").html(res).show();
            })
            .fail(function (_, textStatus) {
                target.find(".modal-loading").hide();
                target.find(".modal-loaded").text(textStatus).show();
            });
    });
})
